module.exports = __webpack_public_path__ + "img/Background0.a3b612d7.jpg";